import WonderType from "@/roc/wonders/base/WonderType";
import WonderKind from "@/roc/wonders/base/WonderKind";
import WonderOwner from "@/roc/wonders/base/WonderOwner";
import Effects from '@/roc/effects/Effects';
import PassiveAura from '@/roc/effects/PassiveAura/PassiveAura';
import PassiveAuraType from '@/roc/effects/PassiveAura/PassiveAuraType';
import EffectAmount from '@/roc/effects/EffectAmount';
import EraType from '@/roc/era/EraType';

const CiteDeCarcassonne = {
  id: '64',
  name: 'Cite de Carcassonne',
  era: EraType.earlyRome,
  icon: 'cdc',
  gameId: 'Carcassonne',
  minLevel: 1,
  maxLevel: 30,
  type: WonderType.STORIES_AND_MYTHS,
  kind: WonderKind.FORTRESS | WonderKind.PALACE,
  kindMultiplier: 1,
  owner: WonderOwner.CAPITAL,
  effects: Effects.create([
    new PassiveAura(
      PassiveAuraType.HEAVY_INFANTRY_CRITICAL_HIT_CHANCE_MOD,
      EffectAmount.asPerLevel([
        30,
        44,
        55,
        65,
        74,  // 5
        82,
        89,
        96,
        102,
        108,  // 10
        114,
        120,
        126,
        131,
        136,  // 15
        141,
        146,
        150,
        155,
        160,  // 20
        164,
        168,
        173,
        177,
        181,  // 25
        185,
        189,
        193,
        196,
        200   // 30
      ]),
      '%',
    ),
    new PassiveAura(
      PassiveAuraType.CARCASSONNE_SENTINELS_PRODUCTION_TIME_BONUS,
      EffectAmount.asPerLevel([
        5,
        11.2,
        14.8,
        17.4,
        19.3,  // 5
        21,
        22.3,
        23.6,
        24.9,
        26.2,  // 10
        27.5,
        28.8,
        30.1,
        31.4,
        32.7,  // 15
        34,
        35.3,
        36.6,
        37.9,
        39.2,  // 20
        40.5,
        40.9,
        41.4,
        41.8,
        42.3,  // 25
        42.7,
        43.2,
        43.6,
        44.1,
        44.5
      ]),
      '%',
    ),
    new PassiveAura(
      PassiveAuraType.HEAVY_INFANTRY_PRODUCTION_TIME_BONUS,
      EffectAmount.asPerLevel([
        5,
        11.2,
        14.8,
        17.4,
        19.3,  // 5
        21,
        22.3,
        23.6,
        24.9,
        26.2,  // 10
        27.5,
        28.8,
        30.1,
        31.4,
        32.7,  // 15
        34,
        35.3,
        36.6,
        37.9,
        39.2,  // 20
        40.5,
        40.9,
        41.4,
        41.8,
        42.3,  // 25
        42.7,
        43.2,
        43.6,
        44.1,
        44.5
      ]),
      '%',
    ),
  ]),
  synergies: [],
};

export default CiteDeCarcassonne;
